import { TicketConversationMessage } from './ticket-conversation-message.model';

export class TicketFullModel {
    
    public id: number;
    public typeId: number;
    public statusId: number;
    public assignedToId: number;
    public assignedTo: string;
    public createdAt: string;
    public modifiedAt: string;
    public subject: string;
    public message: string;
    public comment: string;
    public clientId: number;
    public clientType: string;
    public clientsSubtype: string;
    public name: string;
    public responsibleUser: string;
    public messages: Array<TicketConversationMessage>;

    constructor(obj?: any) {
        this.id                 = obj && obj.id                 || null;
        this.typeId             = obj && obj.typeId             || null;
        this.statusId           = obj && obj.statusId           || null;
        this.assignedToId       = obj && obj.assignedToId       || null;
        this.assignedTo         = obj && obj.assignedTo         || '';
        this.createdAt          = obj && obj.createdAt          || '';
        this.modifiedAt         = obj && obj.modifiedAt         || '';
        this.subject            = obj && obj.subject            || '';
        this.message            = obj && obj.message            || '';
        this.comment            = obj && obj.comment            || '';
        this.clientId           = obj && obj.clientId           || null;
        this.clientType         = obj && obj.clientType         || '';
        this.clientsSubtype     = obj && obj.clientsSubtype     || '';
        this.name               = obj && obj.name               || '';
        this.responsibleUser    = obj && obj.responsibleUser    || null;
        this.messages           = obj && obj.messages           || [];
    }
}



// WEBPACK FOOTER //
// ./src/app/models/ticket-full.model.ts